/**
 * @generated SignedSource<<b2b47680f1aff8001942dba0a84c3950>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ActiveProductContext_useProductSlugHistoryRedirect$data = {
  readonly historicalSlug: {
    readonly occurrenceId: string | null;
  } | null;
  readonly slug: string;
  readonly " $fragmentType": "ActiveProductContext_useProductSlugHistoryRedirect";
};
export type ActiveProductContext_useProductSlugHistoryRedirect$key = {
  readonly " $data"?: ActiveProductContext_useProductSlugHistoryRedirect$data;
  readonly " $fragmentSpreads": FragmentRefs<"ActiveProductContext_useProductSlugHistoryRedirect">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "slug"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "ActiveProductContext_useProductSlugHistoryRedirect",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "slug",
      "storageKey": null
    },
    {
      "alias": null,
      "args": [
        {
          "kind": "Variable",
          "name": "slug",
          "variableName": "slug"
        }
      ],
      "concreteType": "SlugHistory",
      "kind": "LinkedField",
      "name": "historicalSlug",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "occurrenceId",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Product",
  "abstractKey": null
};

(node as any).hash = "3de88477c7a89a4ff013ce3b616220e6";

export default node;
